class CartCount extends HTMLElement {
  constructor() {
    super();

    this.updateCount();

    document.addEventListener("addtocart", () => {
      this.updateCount();
    });

    document.addEventListener("cart:change", (event) => {
      this.textContent = event.detail.item_count;
    });
  }

  updateCount() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        this.textContent = cart.item_count;
      });
  }
}

customElements.define("component-cart-count", CartCount);